<style lang="less" scoped>
    .chart-container{
        position: relative;
        border: 1px solid #dddee1;
        padding-top: 5px;
        .chart{
            margin-top: 10px;
        }
        .ivu-checkbox-wrapper{
            border: 1px solid #dcdee2;
            border-radius: 3px;
            padding: 1px 5px 1px 5px;
            min-height: 24px;
            margin-right: 0;
        }
    }
    .data-empty{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 24px;
    }
</style>
<template>
    <div>
        <div class="chart-container line text-center">
            <div class="text-bold line">销售出库</div>
            <RadioGroup v-model="params.type" @on-change="getStockData" type="button" size="small">
                <Radio label="day">按日</Radio>
                <Radio label="month">按月</Radio>
            </RadioGroup>
            <Select size="small" v-model="params.years" @on-change="getStockData" multiple :max-tag-count="1" :style="years_style">
                <Option v-for="year in years" :value="year" :key="year">{{ year }}年</Option>
            </Select>
            <Checkbox v-model="show_average" size="small"  @on-change="recoveryDataZoom">显示平均值</Checkbox>
            <Checkbox v-model="show_label" size="small"  @on-change="recoveryDataZoom">显示数值</Checkbox>
            <VeLine class="chart"
                    :after-set-option="getOption"
                    :data="chart_data"
                    :settings="chart_setting"
                    :extend="chart_extend"
                    :mark-point="mark_point"
                    :mark-line="mark_line"
                    :data-zoom="data_zoom"
                    :grid="{right: 40}"
                    :events="chart_events"
                    resizeable
                    :loading="loading">
            </VeLine>
            <div class="data-empty" v-if="data_empty">没有出库数据</div>
<!--            <Spin fix v-if="loading"></Spin>-->
        </div>
    </div>
</template>
<script>
    import StockUtil from '../libs/util';
    import VeLine from 'v-charts/lib/line.common';
    import 'echarts/lib/component/markLine'
    import 'echarts/lib/component/markPoint'
    import 'echarts/lib/component/dataZoom';
    import 'v-charts/lib/style.css';

    const now = new Date();
    const last_year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    export default {
        components: { VeLine },
        props: {
            stock_id: {
                type: Number,
            },
        },
        data(){
            return {
                params: {
                    type: 'day',
                    years: [last_year],
                },
                today: {
                    month: now.getMonth() + 1,
                    day: now.getDate(),
                },
                loading: false,
                show_average: true,
                show_label: false,
                chart_data: {
                    columns: [],
                    rows: []
                },
                /*chart_setting: {
                    // xAxisType: 'time',
                },*/
                data_zoom: [
                    {
                        type: 'slider',
                        start: 0,
                        end: 20
                    }
                ],
                changed_data_zoom: [
                    {
                        type: 'slider',
                        start: 0,
                        end: 20
                    }
                ],
                chart_events: {
                    datazoom: (e) => {
                        this.changed_data_zoom[0].start = e.start;
                        this.changed_data_zoom[0].end = e.end;
                    }
                },
                data_empty: false
            }
        },
        computed: {
            years() {
                const years = [];
                for (let i = last_year; i >= 2019; i--){
                    years.push(i);
                }
                return years;
            },
            years_style() {
                return {
                    textAlign: 'left',
                    width: this.params.years.length > 1 ? '160px' : '100px'
                }
            },
            chart_extend() {
                return {
                    series: {
                        label: {show: this.show_label},
                        smooth: false,
                        type: 'line',
                    },
                }
            },
            mark_line() {
                return this.show_average ? {
                    data: [
                        {
                            name: '平均线',
                            type: 'average'
                        }
                    ]
                } : {}
            },
            mark_point() {
                return {
                    data: [
                        {
                            // type: 'max',
                            symbol: 'diamond',
                            symbolSize: 12,
                            coord: [this.params.type === 'day' ? `${this.today.month}-${this.today.day}` : `${this.today.month}月`, 0],
                            itemStyle: {
                                color: '#668CFF'
                            }
                        }
                    ]
                }
            },
            chart_setting() {
                const setting = {
                    xAxisType: 'category',
                    labelMap: {}
                };
                this.params.years.forEach((year) => {
                    setting.labelMap[`${year}_qty`] = `${year}`
                });
                return setting;
            }
        },
        created(){
            this.getStockData();
            this.updateToday();
            // 半小时更新一次
            this.timer = setTimeout(() => {
                this.updateToday();
            }, 1800 * 1000);
        },
        mounted(){
            //
        },
        beforeDestroy() {
            clearTimeout(this.timer);
        },
        methods: {
            updateToday() {
                const now = new Date();
                const month = now.getMonth() + 1;
                const day = now.getDate();
                this.today.month = month;
                this.today.day = day;
            },
            getStockData(){
                if(this.params.years.length === 0){
                    this.params.years = [last_year];
                }
                if (this.loading) return;
                this.loading = true;
                this.$util.ajax.get(this.$util.api.stock_out_data, {
                    params: Object.assign({
                        stock_id: this.stock_id
                    }, this.params)
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        const data = res.data;
                        this.data_empty = data.records.length === 0;
                        this.chart_data = data.chart_data;
                        this.data_zoom = data.data_zoom;
                        this.changed_data_zoom = this.$util.clone(data.data_zoom);
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            recoveryDataZoom() {
                this.data_zoom = this.changed_data_zoom;
            },
            getOption(o){
                console.log(o._api.getOption());
            }
        }
    }
</script>
